import { useMemo } from 'react'
import { isAdmin } from '../../../../../services/AccountService'

export const useNewHeadCheckbox = (
  firstStatus: number,
  data: any,
  checkboxStore: any,
) => {
  const {
    isAllChecked,
    isIndeterminate,
    toggleAllSelection,
    reportStatus,
    status,
    allIds,
    updateSelectedIds,
    selectedIds,
  } = checkboxStore

  const onHeadCheckboxClick = () => {
    if (!status && data?.content.length) {
      const newIds = data.content
        .filter((el: any) =>
          firstStatus ? el.status === firstStatus : roleFilter(el),
        )
        .map((el: any) => el.id)

      updateSelectedIds(newIds, selectedIds)
    }

    const shouldReset = isAllChecked

    toggleAllSelection(status || firstStatus, reportStatus as number)

    if (shouldReset) {
      const newIds = data.content
        .filter((el: any) => roleFilter(el))
        .map((el: any) => el.id)
      checkboxStore.firstStatus = null
      updateSelectedIds(newIds, [])
    }
  }

  return useMemo(
    () => ({
      onHeadCheckboxClick,
      isAllChecked,
      isIndeterminate,
      isHeadCheckboxDisabled: !allIds.length || !data?.content.length,
    }),
    [
      isAllChecked,
      isIndeterminate,
      allIds,
      data,
      firstStatus,
      onHeadCheckboxClick,
    ],
  )
}

const roleFilter = (el: any) =>
  isAdmin() ? [1, 2, 4].includes(el.status) : true
